// Dependency-free ray-cast point-in-polygon test over the app's ring shape
// (Array<{lat, lng}>). Used to decide whether a resolved place falls inside
// a dedicated page's boundary. Treats lat/lng as planar — fine at municipio
// scale; boundary membership near the edge is not a precision-critical
// decision (an off-by-meters miss just routes the user to the general
// search page, which remains correct).
export const pointInPolygon = (point, ring) => {
    if (!Array.isArray(ring) || ring.length < 3) return false;
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const yi = ring[i].lat;
        const xi = ring[i].lng;
        const yj = ring[j].lat;
        const xj = ring[j].lng;
        const crosses =
            yi > point.lat !== yj > point.lat &&
            point.lng < ((xj - xi) * (point.lat - yi)) / (yj - yi) + xi;
        if (crosses) inside = !inside;
    }
    return inside;
};

// Convenience: inside ANY of the rings (multi-ring boundaries are unions).
export const pointInAnyPolygon = (point, rings) =>
    Array.isArray(rings) && rings.some((ring) => pointInPolygon(point, ring));
